import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  DropdownMenu,
  Dropdown,
} from 'semantic-ui-react'

import OutClick from './out_click.js'

import { getText, stopEventPropagation } from '../helpers';

class TagsDropdown extends Component {
  constructor(props){
    super(props);

    this.state = {
      showDropdown: false,
      tagOptions: this.sortTags(this.props.tagOptions),
      tagList: this.props.tagList ? this.props.tagList : [],
      translations: this.props.translations,
      right: 'auto',
      bottom: 'auto',
      searchTerm: '',
      newOption: '',
      showNewOption: false
    }
    
    this.wrapperRef = React.createRef();
  }

  componentWillReceiveProps = (nextProps) => {
    var translations = this.state.translations
    if (nextProps.translations !== this.props.translations ){
      translations = nextProps.translations

    }

    var tagOptions = this.state.tagOptions
    if (nextProps.tagOptions !== this.props.tagOptions){
      tagOptions = this.sortTags(nextProps.tagOptions)
    }

    var tagList = this.state.tagList
    if (nextProps.tagList !== this.props.tagList){
      tagList = nextProps.tagList
    }

    this.setState({
      translations: translations,
      tagOptions: tagOptions,
      tagList: tagList
    })
  }

  componentDidMount = () => {
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount = () => {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  handleClickOutside = (event) => {
    if (!this.wrapperRef.current) return;

    if (this.wrapperRef && !this.wrapperRef.current.contains(event.target)) {
      this.setState({
        showDropdown: false,
        showNewOption: false,
        right: 'auto',
        bottom: 'auto',
        searchTerm: '',
        newOption: ''
      });
    }
  }

  toggleNewOption = () => {
    this.setState({
      showNewOption: !this.state.showNewOption
    })
  }

  sortTags(tags){
    tags.sort(function(tag_one, tag_two){
      if( tag_one < tag_two) { return -1; }
      if( tag_one > tag_two) { return 1; }
      return 0;
    })

    return tags
  }

  onMouseLeave = e => {
    e.stopPropagation();

    this.setState({
      showDropdown: false,
      showNewOption: false,
      right: 'auto',
      bottom: 'auto',
      searchTerm: '',
      newOption: ''
    })
  }

  onItemClick = (item) => { 
    const { confirmRemove, confirmRemoveCallback } = this.props;
    let { tagList } = this.state;
    if (tagList.includes(item)) {
      if (confirmRemove && item==='Active'){
        confirmRemoveCallback(item);
      } else {
        this.removeItemFromList(tagList, item);
      }
    } else {
      this.addItemToList(tagList, item);
    }
  }

  addItemToList = (tagList, item) => {
    tagList.push(item)
    this.udpateTagList(tagList)
  }

  removeItemFromList = (tagList, item) => {
    var index = tagList.indexOf(item);
    if (index !== -1) tagList.splice(index, 1);
    this.udpateTagList(tagList)
  }

  udpateTagList = (tagList) => {
    this.setState({
      tagList: tagList
    }, ()=>{
      this.props.onApply(this.state.tagList)
    })
  }

  filteredOptions = () => {
    return this.state.tagOptions.filter((item)=>{
      return item.toLowerCase().includes(this.state.searchTerm.toLowerCase())
    })
  }

  onSearch = (evt) => {
    this.setState({
      searchTerm: evt.target.value
    })
  }

  onNewChange = (evt) => {
    this.setState({
      newOption: evt.target.value
    })
  }

  onNewSave = (evt) => {
    this.props.onNewTag(this.state.newOption)
    var tagList = this.state.tagList
    if (!tagList.includes(this.state.newOption)){
      tagList.push(this.state.newOption)
    }
    this.setState({
      newOption: '',
      showNewOption: false,
      tagList: this.sortTags(tagList),
    }, ()=>{
      this.props.onApply(this.state.tagList)
    })
  }

  onNewCancel = (evt) => {
    this.setState({
      newOption: '',
      showNewOption: false
    })
  }

  render() {
    const {trigger, header, searchable, addable, doneable, searchPlaceholder, newPlaceholder, translations} = this.props;
    const { search_tags, enter_new_tag, no_match_found, create_new, save, cancel } = translations;
    let { tagOptions, searchTerm } = this.state;
    tagOptions = searchTerm.length > 0 ? this.filteredOptions() : tagOptions;
    
    return (
      <OutClick className={this.props.className || "tags-dropdown"} style={this.props.style} handleClick={this.onMouseLeave}>
        <Dropdown text={trigger}>
          <DropdownMenu className="dropdown-modal" onClick={stopEventPropagation} onDoubleClick={stopEventPropagation}>
            <div className="dropdown-modal-header">
              <div>{header}</div>
              {
                searchable &&
                <form autoComplete="off">
                  <div className="search-tag-container">
                    <input type="text" name="search_tag" defaultValue={this.state.searchTerm} onChange={this.onSearch} placeholder={searchPlaceholder ? searchPlaceholder : search_tags}/>
                  </div>
                </form>
              }
            </div>
            <div className="dropdown-modal-content">
              <ul>
                {
                  tagOptions.map((item, index)=>{
                    return (
                      <li key={index} onClick={(evt)=>this.onItemClick(item)}><input type="checkbox" checked={this.state.tagList.includes(item)} onChange={(evt)=>{evt.stopPropagation()}}/>&nbsp;&nbsp;{item}</li>
                    )
                  })
                }
              </ul>
              {
                this.state.searchTerm.length > 0 && tagOptions.length === 0 &&
                <ul>
                  <li>{no_match_found}</li>
                </ul>
              }
            </div>
            {
              addable &&
              <div className="dropdown-modal-footer">
                {
                  !this.state.showNewOption &&
                  <div className="action" onClick={()=>this.toggleNewOption()}>{create_new}</div>
                }
                {
                  this.state.showNewOption &&
                  <div className="create-new-container">
                    <form autoComplete="off">
                      <input type="text" name="new_tag" defaultValue={this.state.newOption} onChange={this.onNewChange} placeholder={newPlaceholder ? newPlaceholder : enter_new_tag}/>
                    </form>
                    {
                      this.state.newOption
                      ?
                      <div className="action " onClick={this.onNewSave}>{save}</div>
                      :
                      <div className="action disabled">{save}</div>
                    }

                    <div className="action" onClick={this.onNewCancel}>{cancel}</div>
                  </div>
                }
              </div>
            }
            {
              !this.state.showNewOption && doneable &&
              <div className="dropdown-modal-footer">
                <div className="action" onClick={() => this.props.onDone(this.state.tagList)}>{getText("Apply")}</div>
              </div>
            }
          </DropdownMenu>
        </Dropdown>
      </OutClick>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    translations: state.language.language.translations,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(TagsDropdown);



// WEBPACK FOOTER //
// ./src/components/tags_dropdown.js